export const customSizeHeight = [
    {
        id: 1,
        height: "5'0"
    },
    {
        id: 2,
        height: "5'2"
    },
    {
        id: 3,
        height: "5'4"
    },
    {
        id: 4,
        height: "5'6"
    },
    {
        id: 5,
        height: "6'0"
    },
    {
        id: 6,
        height: "6'2"
    },
]

export const customBodyType = [
    {
        id: 1,
        image:'../../../images/bodytype7.png',
        type:'Triangle(Pear)'
    },
    {
        id: 2,
        image:'../../../images/bodytype8.png',
        type:'Inverted triangle'
    },
    {
        id: 3,
        image:'../../../images/bodytype9.png',
        type:'Round (Apple)'
    },
    {
        id: 4,
       image:'../../../images/bodytype10.png',
        type:'Rectangle'
    },
    {
        id: 5,
        image:'../../../images/bodytype11.png',
        type:'Hourglass'
    }
]